import { FC } from 'react';

import { DesktopMenuDropdown } from './DesktopMenuDropdown';

import { Link } from '@/components/shared/Link';
import { formatPathname } from '@/helpers/routing';
import { HeaderDropdowns, HeaderDropdownsState, SiteMenuItem } from '@/types';

interface IHeaderMenuProps {
  siteMenu: SiteMenuItem[];
  expandedState: HeaderDropdownsState;
  toggleDropdown: (dropdownKey: HeaderDropdowns) => void;
}

export const HeaderMenu: FC<IHeaderMenuProps> = ({ siteMenu, expandedState, toggleDropdown }) => (
  <nav className="hidden justify-end pt-4 lg:flex">
    <ul className="flex items-center justify-end space-x-4">
      {siteMenu.map(({ name, slug, dropdown = [] }) => (
        <li key={slug}>
          {!!dropdown?.length ? (
            <DesktopMenuDropdown
              open={expandedState[slug]}
              setOpen={() => toggleDropdown(slug)}
              name={name}
              subItems={dropdown}
            />
          ) : (
            <Link href={formatPathname(slug)} className="font-semibold">
              {name}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </nav>
);
